export const CURRENCY_SYMBOLS: { [key: string]: string } = {
  VND: '₫',
  USD: '$',
  EUR: '€',
  GBP: '£',
  DZD: 'DA',
  ARS: '$ (ARS)',
  AUD: '$ (AUD)',
  BDT: 'Tk',
  BOB: '$b',
  BRL: 'R$',
  CAD: '$ (CAD)',
  CLP: '$ (CLP)',
  CNY: '¥ (CNY)',
  COP: '$ (COP)',
  CRC: '₡',
  CZK: 'Kč',
  DKK: 'kr.',
  EGP: '£ (EGP)',
  GTQ: 'Q',
  HNL: 'L',
  HKD: 'HK$',
  HUF: 'Ft',
  ILS: '₪',
  IDR: 'Rp',
  INR: '₹',
  ISK: 'kr',
  JPY: '¥ (JPY)',
  KES: 'KSh',
  MOP: 'MOP$',
  MYR: 'RM',
  MXN: '$ (MXN)',
  TWD: 'NT$',
  NZD: '$ (NZD)',
  NIO: 'C$',
  NGN: '₦',
  NOK: 'kr',
  PKR: '₨',
  PYG: 'Gs',
  PEN: 'S/.',
  PHP: '₱',
  PLN: 'zł',
  QAR: '﷼',
  RON: 'lei',
  RUB: '₽',
  SAR: '﷼',
  SGD: '$ (SGD)',
  ZAR: 'R',
  KRW: '₩',
  SEK: 'kr',
  CHF: 'CHF',
  THB: '฿',
  TRY: 'TL',
  AED: 'د.إ',
  UYU: '$U',
  VEF: 'Bs.',
};

export const DEFAULT_CURRENCY = 'USD';

export const symbolForCurrency = (code: string) =>
  CURRENCY_SYMBOLS[code] || `$ ${code}`;
export const currencySubCode = (code: string) =>
  symbolForCurrency(code).split(' ')[1]?.slice(1, -1);
export const pureSymbolForCurrency = (code: string) =>
  symbolForCurrency(code).split(' ')[0];
